import React from 'react';
import { Box } from '@mui/material';
import { useLocation, Link } from 'react-router-dom';
import { VotemateLogo } from '../votemate-logo/VotemateLogo';

interface BrandingProps {
  logoSize?: number;
}

export const Branding: React.FC<BrandingProps> = ({ logoSize = 30 }) => {
  const location = useLocation();
  const isOnChatRoute = location.pathname === '/chat';

  const logoElement = (
    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
      <VotemateLogo size={logoSize} />
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        marginTop: 0,
      }}
    >
      {isOnChatRoute ? (
        logoElement
      ) : (
        <Link to="/chat" style={{ textDecoration: 'none', color: 'inherit' }}>
          {logoElement}
        </Link>
      )}
    </Box>
  );
};
